import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Lock extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M14,8.1h-0.3V5.7C13.7,2.6,11.2,0,8,0C4.8,0,2.3,2.6,2.3,5.7v2.4H2l-1,1V17l1,1h12l1-1V9.1L14,8.1z M4.3,5.7
          C4.3,3.7,6,2,8,2c2,0,3.7,1.7,3.7,3.7v2.4H4.3V5.7z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Lock.js